import { epApiAxios } from "config/axios/ep";
import { Game } from "src/model/Game";

export const GameService = {
  // use this for creating a session for each gameplay
  async createGamePlaySession() {
    const res = await epApiAxios.post(`/session/create`);
    return res.data?.ssid;
  },
  async FavoriteGamesList() {
    const res = await epApiAxios.get(`/user_game/favourite/list`);
    return Game.fromAll(res?.data?.games);
  },
  async addToFavorites(gameId) {
    const res = await epApiAxios.post(`/user_game/favourite/create`, {
      game_id: gameId,
    });
    return res;
  },
  async removeFromFavorites(gameId) {
    const payload = {
      game_id: gameId,
    };
    const res = await epApiAxios.delete(`/user_game/favourite/delete`, {
      data: payload,
    });
    return res;
  },
};
